import Component from '@glimmer/component'
import { StudentsTableReport } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/students-table/report'
import type ReportingService from 'teacher-ui-client/services/reporting'
import { service } from '@ember/service'
import { Product } from 'teacher-ui-client/utils/products'
import { trackedFunction } from 'reactiveweb/function'
import { toRequestScope, type BaseReport, type BaseReportMetaPaging } from 'teacher-ui-client/services/reporting'
import type { UIScope } from 'teacher-ui-client/reporting/ui-scope/route'
import type { NormalizedInterval } from 'date-fns'
import { NoReportValue } from 'teacher-ui-client/components/reporting/no-report-value'
import { keepLatest } from 'reactiveweb/keep-latest'
import { use } from 'ember-resources'
import ContentTile from 'teacher-ui-client/components/tiles/content'
import { array } from '@ember/helper'

export interface ReportData extends BaseReport {
  students: {
    first_name: string
    grade_position: number
    id: string
    last_name: string
    school_class_names: string[]
    teacher_names: string[]
    total_assignments_completed: number
    average_lexile_formatted: Nullable<string>
  }[]
  meta: BaseReportMetaPaging
}

interface ReportLoaderSignature {
  Args: {
    uiScope: UIScope
    period: NormalizedInterval
    sort: string
    pageNumber: number
    perPage: number
  }
}

export class ReportLoader extends Component<ReportLoaderSignature> {
  @service reporting!: ReportingService

  fetchReport = trackedFunction(this, async () => {
    const requestScope = toRequestScope(this.args.uiScope)
    const url = this.reporting.buildGravityUrl({
      product: Product.REX,
      requestScope,
      reportName: 'read-aloud-fluency/statistics/students-table',
    })
    const query = this.reporting.buildQuery({
      sort: this.args.sort,
      page: {
        number: this.args.pageNumber,
        size: this.args.perPage,
      },
      period: this.args.period,
    })
    return this.reporting.fetchReport<ReportData>(url, query)
  })

  @use
  latestReport = keepLatest({
    value: () => this.fetchReport.value,
    when: () => this.fetchReport.isPending,
  }); /* prettier-ignore */ /* prettier-ignore-end */

  <template>
    {{#if this.latestReport}}
      <ContentTile>
        <StudentsTableReport
          @isReloading={{this.fetchReport.isPending}}
          @reportData={{this.latestReport}}
          @scopeName={{@uiScope.scope}}
        />
      </ContentTile>
    {{else}}
      <ContentTile class="p-4">
        <NoReportValue @reportStates={{array this.fetchReport}} />
      </ContentTile>
    {{/if}}
  </template>
}
